import './EditBox.sass';

export const EditBox = ({children, className}) => (
  <div className={`edit_box ${className}`}>{children}</div>
);
